import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        groupLabel: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            marginBottom: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        groupLabelText: {
            fontWeight: 'medium',
            textStyle: 'body-medium',
            color: 'foreground.neutral.subtle',
        },
        groupLabelValue: {
            fontWeight: 'medium',
            textStyle: 'body-medium',
            color: 'foreground.neutral.default',
        },
        tabsWrapper: {
            flexDirection: 'column',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            width: '100%',
        },
        tab: {
            display: 'flex',
            height: remCalc(50),
            p: 0,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 0,
            alignSelf: 'stretch',
            width: '100%',
            textAlign: 'left',
            textStyle: 'body-small',
            borderRadius: 'large-1',
            border: 'none',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
            _focusVisible: {
                outline: 'unset',
                border: 'none',
                boxShadow:
                    '0 0 0 1px var(--chakra-colors-background-base-default) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 2px var(--chakra-shadows-accent-lg) !important',
            },
        },
        tabContent: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            height: '100%',
            px: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        tabDefault: {
            borderRadius: 'large-1',
            bg: 'background.base.under',
            color: 'foreground.neutral.default',
            _hover: {
                bg: 'background.base.under',
            },
        },
        tabSelected: {
            borderRadius: 'large-1',
            bg: 'background.base.elevated',
            color: 'foreground.neutral.default',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            _hover: {
                bg: 'background.base.elevated',
            },
        },
        radioIndicator: {
            flexShrink: 0,
            width: remCalc(16),
            height: remCalc(16),
            borderRadius: 'full',
            border: '2px solid',
            borderColor: 'border.neutral.default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        radioIndicatorSelected: {
            flexShrink: 0,
            width: remCalc(16),
            height: remCalc(16),
            borderRadius: 'full',
            bg: 'checkbox.bg.checked',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'foreground.accent.inverse',
        },
        radioCheckIcon: {
            width: remCalc(7.8),
            height: remCalc(5.7),
        },
    },
}
